import React from "react";
import Slider from "react-slick";
// import Group from "../../assets/group.png";
// import { CarouselList } from "../../utils/index";

const Carousels = (props) => {
  const config = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
    arrows: false,
    // dotsClass: "tre_dots slick-dots mt-4 pt-4",
    swipe: true,
  };

  return (
    <div className={`${props.ClassProps}`}>
      <Slider {...config}>
        {props.CarouselList.map((x, i) => {
          return (
            <div key="{i}" className="img-card">
              {/* <img className="mx-auto " src={x.img} alt={x.title} /> */}
              {x.img}
              <div className="card-body">
                <div className="card-title my-3 tre font-28">{x.title}</div>
                <div
                  className="card-text mb-4 "
                  style={{ fontSize: "20px", marginTop: "0px" }}
                >
                  {x.text}
                </div>
              </div>
            </div>
          );
        })}
      </Slider>
    </div>
  );
};

export default Carousels;
